import { useState, useEffect } from "react";
import Select from "react-select";
import CustomModal from "../../components/CustomComponents/modal/customModal";
import FormInput from "../../components/CustomComponents/Input/formInput";
import showErrorToast from "../../components/CustomComponents/toast/toast";

function PaymentMethodModal({
  isModalOpen,
  setIsModalOpen,
  onPaymentMethodSubmit,
  compID,
  paymentMethodToEdit = null,
}) {
  const [paymentData, setPaymentData] = useState({
    cardNumber: "",
    cardHolderName: "",
    expiryDate: "",
    cvv: "",
    // cardType: "",
    // isDefault: false
  });

//   const cardTypeOptions = [
//     { value: "visa", label: "Visa" },
//     { value: "mastercard", label: "Mastercard" },
//     { value: "amex", label: "American Express" },
//     { value: "discover", label: "Discover" },
//     { value: "diners", label: "Diners Club" },
//   ];

  useEffect(() => {
    if (paymentMethodToEdit) {
      setPaymentData({
        id: paymentMethodToEdit.id,
        cardNumber: paymentMethodToEdit.cardNumber,
        cardHolderName: paymentMethodToEdit.cardHolderName,
        expiryDate: paymentMethodToEdit.expiryDate,
        cvv: paymentMethodToEdit.cvv,
        // cardType: paymentMethodToEdit.cardType,
        // isDefault: paymentMethodToEdit.isDefault,
      });
    }
  }, [paymentMethodToEdit]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setPaymentData({
      cardNumber: "",
      cardHolderName: "",
      expiryDate: "",
      cvv: "",
    //   cardType: "",
    //   isDefault: false
    });
  };

  const handleSubmit = () => {
    try {
      if (!paymentData.cardNumber || paymentData.cardNumber.trim().length === 0) {
        showErrorToast("Please enter a valid card number");
        return;
      }

      if (!paymentData.cardHolderName || paymentData.cardHolderName.trim().length === 0) {
        showErrorToast("Please enter card holder name");
        return;
      }

      if (!paymentData.expiryDate || paymentData.expiryDate.trim().length === 0) {
        showErrorToast("Please enter expiry date");
        return;
      }

      if (!paymentData.cvv || paymentData.cvv.trim().length === 0) {
        showErrorToast("Please enter CVV");
        return;
      }

    //   if (!paymentData.cardType) {
    //     showErrorToast("Please select card type");
    //     return;
    //   }

      const formattedCardNumber = paymentData.cardNumber.replace(/\s/g, "").replace(/(\d{4})/g, "$1 ").trim();

      const submitData = {
        ID: paymentMethodToEdit ? paymentMethodToEdit.id : 0,
        cardNumber: formattedCardNumber,
        cardHolderName: paymentData.cardHolderName,
        expiryDate: paymentData.expiryDate,
        cvv: paymentData.cvv,
        cardType: paymentData.cardType,
        // isDefault: paymentData.isDefault,
        compID: compID,
        updateDateTime: new Date().toISOString(),
      };

      onPaymentMethodSubmit(submitData, !!paymentMethodToEdit);
      setIsModalOpen(false);
      setPaymentData({
        cardNumber: "",
        cardHolderName: "",
        expiryDate: "",
        cvv: "",
        cardType: "",
        // isDefault: false
      });
    } catch (err) {
      showErrorToast("Something went wrong.");
    }
  };

  const handleCardNumberChange = (e) => {
    const value = e.target.value;
    const digits = value.replace(/\D/g, "");
    const truncated = digits.substring(0, 16);
    const formatted = truncated.replace(/(\d{4})/g, "$1 ").trim();
    
    setPaymentData({
      ...paymentData,
      cardNumber: formatted,
    });
  };

  const handleExpiryDateChange = (e) => {
    const value = e.target.value;
    const digits = value.replace(/\D/g, "");
    let formatted = digits;
    if (digits.length > 2) {
      formatted = `${digits.substring(0, 2)}/${digits.substring(2, 4)}`;
    }
    
    setPaymentData({
      ...paymentData,
      expiryDate: formatted,
    });
  };

  const handleCvvChange = (e) => {
    const value = e.target.value;
    const cvv = value.replace(/\D/g, "").substring(0, 4);
    
    setPaymentData({
      ...paymentData,
      cvv,
    });
  };

//   const handleCardTypeChange = (selectedOption) => {
//     setPaymentData({
//       ...paymentData,
//       cardType: selectedOption.value,
//     });
//   };

  return (
    <CustomModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      onSubmit={handleSubmit}
      title={paymentMethodToEdit ? "Update Payment Method" : "Add Payment Method"}
      subtitle={"ServeIQ supports a wide range of major credit and debit cards."}
      showButton={true}
      isCentered={true}
      submitButtonText={paymentMethodToEdit ? "Update" : "Add"}
    >
      <div className="row g-3 mb-4">
        <div className="col-md-12">
          <FormInput
            label="Card Number"
            placeHolder="XXXX XXXX XXXX XXXX"
            type="text"
            value={paymentData.cardNumber}
            onchange={handleCardNumberChange}
            required
          />
        </div>
        <div className="col-md-12">
          <FormInput
            label="Card Holder Name"
            placeHolder="Enter Card Holder Name"
            type="text"
            value={paymentData.cardHolderName}
            onchange={(e) =>
              setPaymentData({
                ...paymentData,
                cardHolderName: e.target.value,
              })
            }
            required
          />
        </div>
        <div className="col-md-6">
          <FormInput
            label="Expiry Date"
            placeHolder="MM/YY"
            type="text"
            value={paymentData.expiryDate}
            onchange={handleExpiryDateChange}
            required
          />
        </div>
        <div className="col-md-6">
          <FormInput
            label="CVV"
            placeHolder="XXX"
            type="text"
            value={paymentData.cvv}
            onchange={handleCvvChange}
            required
          />
        </div>
        {/* <div className="col-md-12">
          <label className="form-label">Card Type</label>
          <Select
            options={cardTypeOptions}
            value={cardTypeOptions.find(option => option.value === paymentData.cardType)}
            onChange={handleCardTypeChange}
            placeholder="Select Card Type"
            className="react-select"
            classNamePrefix="react-select"
          />
        </div> */}
        {/* <div className="col-md-12">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="defaultCardCheckbox"
              checked={paymentData.isDefault}
              onChange={(e) =>
                setPaymentData({
                  ...paymentData,
                  isDefault: e.target.checked,
                })
              }
            />
            <label className="form-check-label" htmlFor="defaultCardCheckbox">
              Set as default payment method
            </label>
          </div>
        </div> */}
      </div>
    </CustomModal>
  );
}

export default PaymentMethodModal;